import { useEffect, useRef, useState } from "react"

// Sits inside the sortable group row, so it keeps its pointer and key events
// from reaching dnd-kit (drag, Space to pick up) and the row's toggle.
export function GroupNameInput({
	initialValue,
	onCommit,
	onCancel,
}: {
	initialValue: string
	onCommit: (name: string) => void
	onCancel: () => void
}) {
	const [draft, setDraft] = useState(initialValue)
	const inputRef = useRef<HTMLInputElement>(null)
	// Enter unmounts the input, and a blur can follow it; finish once.
	const finished = useRef(false)

	useEffect(() => {
		inputRef.current?.select()
	}, [])

	const finish = (save: boolean) => {
		if (finished.current) return
		finished.current = true
		if (save) onCommit(draft.trim())
		else onCancel()
	}

	const stop = (e: React.SyntheticEvent) => e.stopPropagation()

	return (
		<input
			ref={inputRef}
			aria-label="Group name"
			data-testid="group-name-input"
			value={draft}
			onChange={(e) => setDraft(e.target.value)}
			onBlur={() => finish(true)}
			onKeyDown={(e) => {
				e.stopPropagation()
				if (e.key === "Enter") {
					e.preventDefault()
					finish(true)
				} else if (e.key === "Escape") {
					e.preventDefault()
					finish(false)
				}
			}}
			onPointerDown={stop}
			onClick={stop}
			onDoubleClick={stop}
			// select-text: Safari will not place a caret inside a select-none row.
			className="w-full min-w-0 cursor-text select-text bg-transparent text-left text-sm font-medium text-primary outline-none"
		/>
	)
}
